import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { Suspense, useEffect } from "react";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { AppProvider } from "./Hooks/useAppContext";
import store from "./Redux/store";
import MainLoader from "./Components/Loader/MainLoader";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

const rootElement: any = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Suspense fallback={<MainLoader />}>
      <I18nextProvider i18n={i18n}>
        <AppProvider>
          <App />
        </AppProvider>
      </I18nextProvider>
    </Suspense>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
